import React, { useEffect, useState } from 'react';
import styles from './InputModal.module.scss';
import classnames from 'classnames';
import { InputContainer } from '../InputContainer/InputContainer';
import { fullDateFormatter } from '../../utils/fullDateFormatter';
import { Validity } from '../../interfaces/tip/Validations';

interface InputModalProps {
  label: string;
  ModalItem: React.FC<any>;
  handleChange: (...params: any | any[]) => void;
  value: string | number;
  featured?: any[];
  type?: 'DEFAULT' | 'DATE' | 'STAKE';
  validity?: Validity | false;
  isSpecialChannelSelected?: boolean; 
}

export const InputModal: React.FC<InputModalProps> = ({
  label,
  ModalItem,
  handleChange,
  value,
  featured,
  type = 'DEFAULT',
  validity,
  isSpecialChannelSelected,
}) => {
  const cx = classnames.bind(styles);
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [isHidden, setIsHidden] = useState(false);
  const [isCloseModalBlocked, setIsCloseModalBlocked] = useState(false);

  const isCurrentDate = () => {
    if (type === 'DATE') {
      const startDate = new Date(value);
      const currentDate = new Date();
      return (
        startDate.getUTCFullYear() <= currentDate.getUTCFullYear() &&
        startDate.getUTCMonth() <= currentDate.getUTCMonth() &&
        startDate.getUTCDate() <= currentDate.getUTCDate() &&
        startDate.getUTCHours() <= currentDate.getUTCHours() &&
        startDate.getUTCMinutes() <= currentDate.getUTCMinutes()
      );
    } else return false;
  };
  const closeModal = () => {
    setIsModalOpen(false);
  };
  useEffect(() => {
    if (type === 'DATE') {
      setIsHidden(isCurrentDate);
      if (isCurrentDate()) {
        setIsCloseModalBlocked(true);
      } else {
        setIsCloseModalBlocked(false);
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [value, type]);

  return (
    <>
      <InputContainer label={label} isDropdown validity={validity}>
        <div
          onClick={() => setIsModalOpen(!isModalOpen)}
          className={styles.InputModal}
          id={styles[`${type}`]}
        >
          <span
            className={cx(
              styles.value,
              isHidden ? styles.hiddenValue : styles.unset,
            )}
          >
            {type === 'DATE' && typeof value === 'string'
              ? fullDateFormatter(value)
              : value}
          </span>
          {isModalOpen && (
            <div
              className={styles.modalOverlay}
              onClick={(e: any) => {
                e.preventDefault();
                e.stopPropagation();
                if (isCloseModalBlocked) {
                  return;
                } else {
                  setIsModalOpen(false);
                }
              }}
            >
              <div
                className={cx(styles.Modal, styles.custom)}
                onClick={(e: any) => {
                  e.preventDefault();
                  e.stopPropagation();
                }}
              >
                <ModalItem
                  closeModal={closeModal}
                  handleChange={handleChange}
                  featured={featured}
                  value={value}
                  setIsCloseModalBlocked={setIsCloseModalBlocked}
                  isSpecialChannelSelected={isSpecialChannelSelected}
                />
              </div>
            </div>
          )}
        </div>
      </InputContainer>
    </>
  );
};
